import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { PaginatedResponse } from '@app/entity';
import { Answer, Question } from '@app/entity/faq';
import { API_VERSION } from '@app/core/api.version';

export class AnswerFilters {
  question_id?: number;
}

export interface QuestionFilters {
  search?: string;
  pageSize?: number;
  isPartnerPage?: boolean;
}

@Injectable()
export class FaqService {

  constructor(private http: HttpClient) { }

  getQuestions(pageUrl?: string, filters?: QuestionFilters): Observable<PaginatedResponse<Question>> {
    let params = new HttpParams();
    if (filters && filters.search) params = params.set('search', filters.search);
    if (filters && filters.pageSize) params = params.set('page_size', filters.pageSize + '');
    if (typeof filters.isPartnerPage === 'boolean') params = params.set('is_partners_page', filters.isPartnerPage + '');
    return this.http.get<PaginatedResponse<Question>>(pageUrl || `/${API_VERSION}/faq/questions/`, { params });
  }

  getAnswers(pageUrl?: string, filters?: AnswerFilters): Observable<PaginatedResponse<Answer>> {
    let params = new HttpParams();
    if (filters && filters.question_id) params = params.set('question', filters.question_id + '');
    return this.http.get<PaginatedResponse<Answer>>(pageUrl || `/${API_VERSION}/faq/answers/`, { params });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/faq.service.ts